import { useState } from 'react';
import {
	Avatar,
	Flex,
	Heading,
	Text,
	Spacer,
	useColorModeValue
} from '@chakra-ui/react';
import GrowthBadge from '../../Badge/GrowthBadge';

export interface MetricCardProps {
	name: string;
	metric: number;
	image?: string;
	priorMetricValue?: number;
	onClick?: () => void;
	onNameTextClick?: () => void;
	avatarSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
	titleSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
	showLabel?: boolean;
	buttonText?: string;
	buttonIcon?: JSX.Element;
	onButtonClick?: () => void;
	buttonLoading?: boolean;
	showBorder?: boolean;
	disabled?: boolean;
}

export enum MetricCardSizingConfig {
	CARD_HEIGHT = '60px',
	PANEL_MIN_HEIGHT = '80px'
}

export enum MetricCardStylingConfig {
	BORDER_COLOR_LIGHT = '#f1f3f7',
	BORDER_COLOR_DARK = '#3f434c'
}

export default function MetricCard({ name, image, metric, priorMetricValue, onClick, onNameTextClick, avatarSize = 'sm', titleSize = 'md', showLabel = true, showBorder = true, disabled = false }: MetricCardProps) {
	const [showGrowthBadgeRawDelta, setShowGrowthBadgeRawDelta] = useState<boolean>(true);
	const backgroundColor = useColorModeValue('gray.200', 'gray.800')
	const borderColor = useColorModeValue(MetricCardStylingConfig.BORDER_COLOR_LIGHT, MetricCardStylingConfig.BORDER_COLOR_DARK);

	function renderName() {
		if (showLabel) {
			const contentProps = {
				_hover: onNameTextClick ? { color: 'blue.500' } : {},
				cursor: onNameTextClick ? 'pointer' : '',
				onClick: onNameTextClick
			}

			const label = name

			return (
				<Text fontSize='xs' fontWeight='light' {...contentProps}>
					{label}
				</Text>
			);

		}
	}

	function renderMetric() {
		return (
			<Flex direction={'row'} gap={2}>
				<Heading fontSize={titleSize}>
					{metric.toFixed(2)}
				</Heading>
				{!!priorMetricValue && <GrowthBadge starting={priorMetricValue} ending={metric} showRawDelta={showGrowthBadgeRawDelta} onClick={() => setShowGrowthBadgeRawDelta(!showGrowthBadgeRawDelta)} />}
			</Flex>
		);
	}


	return (
		<Flex
			direction='row'
			alignItems='center'
			gap={2}
			minHeight={MetricCardSizingConfig.CARD_HEIGHT}
			width="100%"
			overflow='hidden'
			onClick={onClick}
			cursor={onClick && !disabled ? 'pointer' : ''}
			padding={showBorder ? '10px' : '10px 0px'}
			border={showBorder ? "1px solid" : 'none'}
			borderColor={borderColor}
			_hover={onClick && !disabled ? { 'backgroundColor': backgroundColor } : {}}
		>
			{!!image && <Avatar size={avatarSize} name={name} src={image} />}
			<Flex direction="column" textAlign="left">
				{renderMetric()}
				{renderName()}
			</Flex>
			<Spacer />
		</Flex>
	);
}
